var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['nut-avatar', 'avatar-' + _vm.size, 'avatar-' + _vm.shape],style:(_vm.styles),on:{"click":_vm.activeAvatar}},[_c('i',{staticClass:"icon",style:(_vm.iconStyles)}),_vm._v(" "),(_vm.isShowText)?_c('span',{staticClass:"text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }